import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from '@react-pdf/renderer';
import { usePDFContext } from './pdf.context';
const headerStyles = StyleSheet.create({
    container: {
        backgroundColor: '#F3F3F3',
        padding: 20,
        paddingTop: 25,
        paddingBottom: 25,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    title: {
        fontSize: 14,
        fontFamily: 'Inter',
        fontWeight: 600
    },
    number: {
        fontSize: 12,
        fontFamily: 'Inter',
        color: '#545454'
    }
});
export const Header = ({ name, number }) => {
    const { Text, View } = usePDFContext();
    return (_jsxs(View, { style: headerStyles.container, children: [_jsx(Text, { style: headerStyles.title, children: name }), _jsx(Text, { style: headerStyles.number, children: number && `#${String(number).padStart(6, '0')}` })] }));
};
